import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { CommonService } from "src/app/Global-Services/common.service";
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  AppTokenHandler,
  HTTPStatus,
} from "src/app/Global-Services/app-token-handler";
import { GlobalVariable } from "src/app/Variable/global-variable";
import { environment } from "src/environments/environment";
import { NgModel } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import { ExcelUploadService } from "src/app/Global-Services/excel-upload.service";

@Component({
  selector: "app-view-access-matrix-record",
  standalone: false,
  templateUrl: "./view-access-matrix-record.component.html",
  styleUrl: "./view-access-matrix-record.component.css",
})
export class ViewAccessMatrixRecordComponent implements OnInit {

  EmployeeName: string[];
  filteredEmployeeSingle: any [] =[];
  reverse = false;
  sortkey: any;
  EmployeeList = {
    Employee: null,
    EmployeeGPN: null
  };
  ViewAccessRecordList = {
    AccessMatrixID: 0,
    EmployeeName: '',
    EmployeeGPN:'',
    ServiceLine: '',
    CountryId: '',
    CountryText: '',
    MargentSegment: '',
    ClientServingId: '',
    ClientServingText: '',
    Location: '',
    Competency: '',
    CurrentUserGPN: '',
    IsExport: false,
    TopRecord: 0,
    TotalRecord: 0,
    RecordFrom: 0,
    RecordTo: 0,
    TotalPageCount: 0,
    currentPage: 1,
    IDList: "",
    IsActive: null as boolean | null,
  };
  ServiceLineList: String[];
  CountryList: String[];
  MargentSegmentList: String[];
  ClientServingList: String[];
  LocationList: String[];
  CompetencyList: String[];
  selectedOptions: string[] = [];
  ViewAccessMatrixRecordList: any[];
  isLoading: boolean = false;

 @ViewChild('txtEmployeeGPN') txtEmployeeGPN?: NgModel;

  constructor(
    public route: ActivatedRoute,
    private confirmBox: ConfirmationService,
    public gService: CommonService,
    public datepipe: DatePipe,
    private gVariable: GlobalVariable,
    private router: Router,
    public ExcelUpload: ExcelUploadService
  ) {}

  ngOnInit() {
    this.filteredEmployeeSingle = [];
    this.GetServiceLine();
    this.GetKeyWordByKeyWordType('ClientServing');
    this.GetLocation();
    this.GetMarketSegmentForDropDown();
    this.GetCompetencyForDropDown();
    this.GetSearchAndExportResult("Search");
    this.ViewAccessRecordList.CurrentUserGPN = this.gVariable.User.UserGPN;
  }

  GetEmpSearch(event: any, isGPNFilter: boolean = false) {
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEmployeeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data!=null && data.length > 0) {
          this.filteredEmployeeSingle = data;
        } else {
          this.EmployeeName = [];
          this.filteredEmployeeSingle = [];
        }
      },
        (err: HttpErrorResponse) => {
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  GetKeyWordByKeyWordType(Value: string, EmpGPN: string = '') {
    this.isLoading = true;
    this.gService.GetKeyWordByKeyWordType(Value, EmpGPN).subscribe((data: any) => {
      if (Value === 'ClientServing') {
        this.ClientServingList = data;
      }
      if (Value === 'Country') {
        this.CountryList = data;
        this.ViewAccessRecordList.CountryId = data[0].KeyWordValue;
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetLocation() {
    this.isLoading = true;
    this.gService.GetLocation().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.LocationList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetMarketSegmentForDropDown() {
    this.isLoading = true;
    this.gService.GetMarketSegmentForDropDown().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.MargentSegmentList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetCompetencyForDropDown() {
    this.isLoading = true;
    this.gService.GetCompetencyForDropDown().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.CompetencyList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }


  OnClearSendUser() {
    this.ViewAccessRecordList.EmployeeName = null;
    this.ViewAccessRecordList.EmployeeGPN = null;
  }

   SetSelectedEmpGPN(event: any) {
    this.ViewAccessRecordList.EmployeeName = event.value.EmpName;
    this.ViewAccessRecordList.EmployeeGPN = event.value.EmpGPN;
  }

  GetServiceLine() {
    this.isLoading = true;
    this.gService.GetServiceLine().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ServiceLineList = data;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  sort(keyname: any) {
    this.sortkey = keyname;   // set the sortKey to the param passed
    this.reverse = !this.reverse; // if true make it false and vice versa
  }

  setPage(PageNumber: any) {
    this.ViewAccessRecordList.currentPage = PageNumber;
    this.GetSearchAndExportResult('Search');
  }
  PreviousPage() {
    this.ViewAccessRecordList.currentPage = this.ViewAccessRecordList.currentPage - 1;
    this.GetSearchAndExportResult('Search');
  }
  NextPage() {
    this.ViewAccessRecordList.currentPage = this.ViewAccessRecordList.currentPage + 1;
    this.GetSearchAndExportResult('Search');
  }
  firstPage() {
    this.ViewAccessRecordList.currentPage = 1;
    this.GetSearchAndExportResult('Search');
  }
  lastPage() {
    this.ViewAccessRecordList.currentPage = this.ViewAccessRecordList.TotalPageCount;
    this.GetSearchAndExportResult('Search');
  }

  range(count: any) {
    const ratings = [];
    let TotalPage = count;
    const Start = this.ViewAccessRecordList.currentPage - 1;
    if (count > 5) {
      TotalPage = this.ViewAccessRecordList.currentPage + 4;
      if (TotalPage > this.ViewAccessRecordList.TotalPageCount) {
        TotalPage = this.ViewAccessRecordList.currentPage + (this.ViewAccessRecordList.TotalPageCount - this.ViewAccessRecordList.currentPage);
      }
    }
    for (let i = Start; i < TotalPage; i++) {
      ratings.push(i);
    }
    return ratings;
  }

  GetSearchAndExportResult(type: string)
  {
    this.ViewAccessRecordList.IDList = '';
    this.isLoading = true;

     if (type == "Search")
      this.ViewAccessRecordList.IsExport = false;
     else{
      for (var i = 0; i < this.ViewAccessMatrixRecordList.length; i++) {
      if (this.ViewAccessMatrixRecordList[i].checked) {
        if (this.ViewAccessRecordList.IDList == '') {
          this.ViewAccessRecordList.IDList = this.ViewAccessMatrixRecordList[i].AccessMatrixID;
        }
        else {
          this.ViewAccessRecordList.IDList += ',' + this.ViewAccessMatrixRecordList[i].AccessMatrixID
        }
      }
    }
      this.ViewAccessRecordList.IsExport = true;
  }

    this.gService.PostService(this.ViewAccessRecordList, 'AccessMatrix/GetAndExportAccessMatrix').subscribe(data => {
      if(type == "Search")
      {
      if (data != null) {
        if (data.length > 0) {

          this.ViewAccessRecordList.TopRecord = data[0]['TopRec'];
          this.ViewAccessRecordList.TotalRecord = data[0]['TotRec'];
          this.ViewAccessRecordList.RecordFrom = data[0]['RecordFrom'];
          this.ViewAccessRecordList.RecordTo = parseFloat(data[0]['RecordFrom']) + (data.length - 1);
          this.ViewAccessRecordList.TotalPageCount = data[0]['TotalPageCount'];
          this.ViewAccessMatrixRecordList = data;
        } else {
          this.ViewAccessMatrixRecordList = data;
          this.ViewAccessRecordList.TopRecord = 0;
          this.ViewAccessRecordList.TotalRecord = 0;
          this.ViewAccessRecordList.RecordFrom = 0;
          this.ViewAccessRecordList.RecordTo = 0;
          this.ViewAccessRecordList.TotalPageCount = 0;
          this.ViewAccessRecordList.currentPage = 1;
        }
      }
    }
    else
    {
        this.ExcelUpload.exportAsExcelFile(data, 'AccessMatrix_List');
    }
    this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  ResetResult()
  {
    this.ViewAccessRecordList.AccessMatrixID = 0;
    this.ViewAccessRecordList.EmployeeName = '';
    this.ViewAccessRecordList.EmployeeGPN ='';
    this.ViewAccessRecordList.ServiceLine = '';
    this.ViewAccessRecordList.CountryId = '';
    this.ViewAccessRecordList.CountryText = '';
    this.ViewAccessRecordList.MargentSegment = '';
    this.ViewAccessRecordList.ClientServingId = '';
    this.ViewAccessRecordList.ClientServingText = '';
    this.ViewAccessRecordList.Location = '';
    this.ViewAccessRecordList.Competency = '';
    this.ViewAccessRecordList.CurrentUserGPN = '';
    this.ViewAccessRecordList.IsExport = false;
    this.ViewAccessRecordList.TopRecord = 0;
    this.ViewAccessRecordList.TotalRecord = 0;
    this.ViewAccessRecordList.RecordFrom = 0;
    this.ViewAccessRecordList.RecordTo = 0;
    this.ViewAccessRecordList.TotalPageCount = 0;
    this.ViewAccessRecordList.currentPage = 1;
    this.EmployeeList.Employee = '';
    this.EmployeeList.EmployeeGPN = '';
    this.ViewAccessRecordList.IsActive = null;
    this.GetSearchAndExportResult('Search');
  }


  onExit()
  {
    let confirm = false;
    const message = 'Are You Sure Want to Exit.';
    confirm = window.confirm(message);

    if (confirm) {
      this.router.navigate(['/INFTE/home']);
    }
  }

  OnClickAccessMatrixRecord(accessMatrixID: any) {
    this.router.navigate(['/View/GrantAccessMatrixComponent/' + accessMatrixID]);
  }

  MarkRecordInActiveAccessMatrix(type: any)
  {
    this.isLoading = true;
    var IDList = '';
    for (var i = 0; i < this.ViewAccessMatrixRecordList.length; i++) {
      if (this.ViewAccessMatrixRecordList[i].checked) {
        if (IDList == '') {
          IDList = this.ViewAccessMatrixRecordList[i].AccessMatrixID;
        }
        else {
          IDList += ',' + this.ViewAccessMatrixRecordList[i].AccessMatrixID
        }
      }
    }

    const param = {
    'IDList': IDList,
    'Type': type
    }

    this.gService.PostDataWithParam('AccessMatrix/MarkRecordInActiveAccessMatrix', param).subscribe(data => {
      if (data != null) {
        if (data == "Success") {
           if(type == "InActive")
          alert("Record has been marked as inActive!");
        else
          alert("Record has been marked as Active!");
          this.GetSearchAndExportResult('Search');
        }
      }
    this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
    }
}
